// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/tableColumns/operatorColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tooltip } from 'antd';
import { parseCnpjToDisplay, returnOnlyNumbers } from 'utils/helpers';
import translateX from 'utils/translateX';
import SimpleAvatar from 'components/SimpleComponents/SimpleAvatar';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function operatorColumn(buildColumnProps, options = {}) {
  const {
    key = 'operatorId',
    title = 'operator',
    dataIndex = '__operator.name',
    width,
    columnProps = { sort: true },
    filterOptions = [],
  } = options;

  // Sort props use dataIndex (backend sorts by __operator.name)
  const sortProps = buildColumnProps(dataIndex, columnProps);

  // Filter props use key as field name (backend filters by operatorId via $match)
  // Only applied when filterOptions are provided from the parent component
  const filterProps = filterOptions.length > 0
    ? buildColumnProps(key, { filter: true, filterOptions })
    : {};

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...sortProps,
    ...filterProps,
    render: (_, r) => {
      const op = r?.__operator;

      if (!op?.name) return <span className="text-muted">—</span>;

      const cnpjRaw = op?.cnpj?.value;
      const subtitle = cnpjRaw ? parseCnpjToDisplay(returnOnlyNumbers(cnpjRaw)) : '—';

      return (
        <div className="d-flex flex-column" style={{ minWidth: 0, flex: 1 }}>
          <Tooltip title={op?.name}>
            <span className="font-weight-semibold text-truncate d-block">{op?.name}</span>
          </Tooltip>
        </div>
      );
    },
  };
}

export default operatorColumn;
